import { CultureIndexTraitName, CultureIndexTraitSymbol } from '../../core/culture-index.model'
import { INode, INodeInterConnection } from './culture-index-chart.model'

const NODE_RADIUS = 9
const NODE_COLOR = '#000'
const NODE_SIZE = 'normal'

export const NODE_COLOR_MAP: Record<CultureIndexTraitSymbol, `#${string}`> = {
  [CultureIndexTraitSymbol.A]: '#B8002B',
  [CultureIndexTraitSymbol.B]: '#FFCC00',
  [CultureIndexTraitSymbol.C]: '#0040B8',
  [CultureIndexTraitSymbol.D]: '#009440',
  [CultureIndexTraitSymbol.L]: '#673AB7',
  [CultureIndexTraitSymbol.I]: '#03A9F4',
}

export const NODES: INode[] = [
  { id: CultureIndexTraitSymbol.A, x: 0, y: 1, radius: NODE_RADIUS, color: NODE_COLOR, borderColor: NODE_COLOR, size: NODE_SIZE },
  { id: CultureIndexTraitSymbol.B, x: 0, y: 2, radius: NODE_RADIUS, color: NODE_COLOR, borderColor: NODE_COLOR, size: NODE_SIZE },
  { id: CultureIndexTraitSymbol.C, x: 0, y: 3, radius: NODE_RADIUS, color: NODE_COLOR, borderColor: NODE_COLOR, size: NODE_SIZE },
  { id: CultureIndexTraitSymbol.D, x: 0, y: 4, radius: NODE_RADIUS, color: NODE_COLOR, borderColor: NODE_COLOR, size: NODE_SIZE },
  { id: CultureIndexTraitSymbol.L, x: 0, y: 6, radius: NODE_RADIUS, color: NODE_COLOR, borderColor: NODE_COLOR, size: NODE_SIZE },
  { id: CultureIndexTraitSymbol.I, x: 0, y: 7, radius: NODE_RADIUS, color: NODE_COLOR, borderColor: NODE_COLOR, size: NODE_SIZE },
]

export const CONNECTIONS: INodeInterConnection[] = [
  { source: CultureIndexTraitSymbol.A, target: CultureIndexTraitSymbol.B },
  { source: CultureIndexTraitSymbol.B, target: CultureIndexTraitSymbol.C },
  { source: CultureIndexTraitSymbol.C, target: CultureIndexTraitSymbol.D },
]

export const CULTURE_INDEX_TRAITS_SYMBOL_TO_NAME: Record<CultureIndexTraitSymbol, CultureIndexTraitName> = {
  [CultureIndexTraitSymbol.A]: CultureIndexTraitName.AUTONOMY,
  [CultureIndexTraitSymbol.B]: CultureIndexTraitName.SOCIAL_ABILITY,
  [CultureIndexTraitSymbol.C]: CultureIndexTraitName.PACE,
  [CultureIndexTraitSymbol.D]: CultureIndexTraitName.CONFORMITY,
  [CultureIndexTraitSymbol.L]: CultureIndexTraitName.LOGIC,
  [CultureIndexTraitSymbol.I]: CultureIndexTraitName.INGENUITY,
}

export const CULTURE_INDEX_TRAITS_NAME_TO_SYMBOL: Record<CultureIndexTraitName, CultureIndexTraitSymbol> = Object.entries(
  CULTURE_INDEX_TRAITS_SYMBOL_TO_NAME
).reduce((acc, [symbol, name]) => {
  acc[name] = symbol as CultureIndexTraitSymbol
  return acc
}, {} as Record<CultureIndexTraitName, CultureIndexTraitSymbol>)
